import { connect } from 'react-redux'
import { compose, withState } from 'recompose'
import { closeLoans } from 'src/actions/homeowner'
import { withElementRef } from 'src/composables'
import { MortgagesPanel } from 'src/constants/notificationRefs'
import { selectLoanFocus } from 'src/store/selectors/home/homeowner'
import {
  selectLoanEditing,
  selectLoanEditingBalance
} from 'src/store/selectors/loan'

const MortgagesPanelContainer = compose(
  connect(
    state => ({
      editing: selectLoanEditing(state),
      editingBalance: selectLoanEditingBalance(state),
      loanFocus: selectLoanFocus(state)
    }),
    dispatch => ({
      closeLoans: e => {
        e.stopPropagation()
        dispatch(closeLoans())
      }
    })
  ),
  withElementRef(MortgagesPanel),
  withState('showPast', 'setShowPast', false)
)

export default MortgagesPanelContainer
